import { FileText, Sparkles, GitBranch, UserCheck, FolderOpen } from 'lucide-react';
import { mockActivityLog, mockUsers } from './mockData';

const iconMap = {
  paper: FileText,
  review: Sparkles,
  version: GitBranch,
  user: UserCheck,
  group: FolderOpen,
};

const ActivityLogTab = () => {
  const userMap = Object.fromEntries(mockUsers.map((u) => [u.id, u.name]));

  return (
    <div className="space-y-1">
      {mockActivityLog.map((entry, index) => {
        const Icon = iconMap[entry.icon];
        const isLast = index === mockActivityLog.length - 1;

        return (
          <div key={entry.id} className="flex gap-4">
            {/* Timeline connector */}
            <div className="flex flex-col items-center">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10">
                <Icon className="h-4 w-4 text-primary" />
              </div>
              {!isLast && <div className="w-px flex-1 bg-border" />}
            </div>

            {/* Content */}
            <div className="pb-6">
              <p className="text-sm font-medium text-foreground">
                {userMap[entry.userId] ?? 'Unbekannt'}{' '}
                <span className="text-muted-foreground font-normal">— {entry.action}</span>
              </p>
              <p className="text-sm text-muted-foreground">{entry.detail}</p>
              <p className="text-xs text-muted-foreground/70 mt-1">
                {new Date(entry.timestamp).toLocaleString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityLogTab;
